module.exports = __webpack_public_path__ + "static/img/consult.199441ab.jpg";